(() => {
  const main = document.querySelector('[data-sl-system]');
  if (!main) return;
  document.addEventListener('variant:update', (event) => {
    if (String(event.detail?.data?.productId) !== main.dataset.slSystem) return;
    const source = event.detail.data.html;
    if (!source) return;
    queueMicrotask(() => {
      const nextMain = source.querySelector('[data-sl-system]');
      if (!nextMain) return;
      main.dataset.slFlavor = nextMain.dataset.slFlavor;
      for (const selector of ['[data-sl-system-selection]', '.sl-description']) {
        const current = main.querySelector(selector);
        const next = nextMain.querySelector(selector);
        if (current && next) {
          const open = Array.from(current.querySelectorAll('details')).map(node => node.open);
          const replacement = next.cloneNode(true);
          replacement.querySelectorAll('details').forEach((node, index) => { node.open = open[index] || false; });
          current.replaceWith(replacement);
        }
      }
      for (const section of document.querySelectorAll('speedlabs-editorial')) {
        if (section.dataset.productId !== main.dataset.slSystem) continue;
        const wrapper = section.closest('.shopify-section');
        const next = wrapper && source.getElementById(wrapper.id)?.querySelector('speedlabs-editorial');
        if (next) section.replaceWith(next.cloneNode(true));
      }
    });
  });
})();
